export default function isTimestampWithinHourAndTenMinutes(timestamp) {
    const currentTime = new Date();
    const givenDate = timestamp;
    const timeDifference = currentTime - givenDate;
    const minutesDifference = Math.abs(timeDifference / (1000 * 60));
    return minutesDifference <= 70;
  }